// Progress bar positions for the purchase flows. Fixed milestones (single
// pages) get a discrete value; stages that walk through a variable number of
// sub-steps (the seat picker's event tabs, the cart's steps) get a band — a
// start value plus a range — that `bandProgress` splits evenly across however
// many sub-steps the order has, so the bar always moves forward.
//
// The two flows are laid out so they never move the bar backwards:
//   CHECKOUT_FLOW:     0 → 10 → 20 → cart[20,80] → 80 → 90
//   SUBSCRIPTION_FLOW: 10 → seatPicker[10,50] → cart[50,80] → 80 → 90
// The sign-in and checkout pages are shared by both flows, so their values live
// on CHECKOUT_FLOW and both carts end at the sign-in value (80).
export const progressBarValues = {
  _RESET: null,
  CHECKOUT_FLOW: {
    INITIAL: 0,
    EVENT_GROUP: 10,
    EVENT: 20,
    CART_START: 20,
    CART_RANGE: 60,
    SIGN_IN: 80,
    CHECKOUT: 90,
  },
  SUBSCRIPTION_FLOW: {
    CHOOSE_EVENTS: 10,
    SEAT_PICKER_START: 10,
    SEAT_PICKER_RANGE: 40,
    CART_START: 50,
    CART_RANGE: 30,
  },
  SIGNUP_FLOW: {
    STEP_ONE: null,
    STEP_TWO: 50,
  },
  // The ticket refund flow (receipt/[receiptId]/refund/[eventId]): method
  // selection, then the optional type-selection screen for a multi-target
  // method, then — for gift card/donation only — the landing page the
  // refund settles on (money never leaves the method screen). Landing pages
  // are shared with the normal purchase flow, so they only set CONFIRM while
  // actually refunding.
  REFUND_FLOW: {
    METHOD: 50,
    TYPE: 75,
    CONFIRM: 90,
  },
};

// Places sub-step `stepIndex` of `stepCount` within a band that starts at
// `start` and spans `range` units. Each step lands on an evenly spaced interior
// point — never the band's start or end — so the bar advances on every step and
// stays clear of the neighbouring milestones. A lone step sits in the middle of
// the band.
export function bandProgress(
  stepIndex: number,
  stepCount: number,
  start: number,
  range: number
): number {
  if (stepCount <= 0) return start;
  const idx = Math.max(0, Math.min(stepIndex, stepCount - 1));
  return start + ((idx + 1) / (stepCount + 1)) * range;
}
